import React, {useState,useEffect,useRef} from 'react';
import { BiSolidCloudUpload } from "react-icons/bi";
import AddUsersTable from './AddUsersTable';
import AddUsersResultsTable from './AddUsersResultsTable';

import { usePapaParse } from 'react-papaparse';
import { sex } from '../constants';
import { createDialog } from 'coaz-ui';
import client from '../client';

const AddUsers = ({params}) => {
    const [districts,setDistricts] = useState([]);
    const [nationalities,setNationalities] = useState([]);
    const [professionalCategories,setProfessionalCategories] = useState([]);
    const [idTypes,setIdTypes] = useState([]);
    const {request,errorMessage} = client;
    const mainContainerRef = useRef(null);

    const { readString } = usePapaParse();
    const pageSize = 10;
    let fileReader;
    
    const handleFileRead = (e) => {
        const content = fileReader.result;
        readString(content, {
            header: true,
            worker: true,
            complete: (results) => {
                let newPages = [];
                let count = 0;
                for(let i = 0;i < results.data.length;) {
                    let page = [];
                    for(let j = 0;j < pageSize;j++) {
                        if(i < results.data.length) {
                            let gender = null;
                            let nationality = null;
                            let professionalCategory = null;
                            let district = null;
                            let idType = null;

                            if(results.data[i].sex && sex && sex.length > 0) {
                                gender = sex.find((sx) => {return sx.trim().toLowerCase() == results.data[i].sex.trim().toLowerCase()});
                            } else {
                                gender = null;
                            }
                            
                            if(results.data[i].nationality && nationalities && nationalities.length > 0) {
                                nationality = nationalities.find((nation) => {return nation.trim().toLowerCase() == results.data[i].nationality.trim().toLowerCase()});
                            } else {
                                nationality = null;
                            }

                            if(results.data[i].professionalCategory && professionalCategories && professionalCategories.length > 0) {
                                professionalCategory = professionalCategories.find((category) => {return category.trim().toLowerCase() == results.data[i].professionalCategory.trim().toLowerCase()});
                            } else {
                                professionalCategory = null;
                            }
                                
                            if(results.data[i].district && districts && districts.length > 0) {
                                district = districts.find((dist) => {return dist.name.trim().toLowerCase() == results.data[i].district.trim().toLowerCase()});
                            } else {
                                district = null;
                            }

                            if(results.data[i].idType && idTypes && idTypes.length > 0) {
                                idType = idTypes.find((iType) => {return iType.trim().toLowerCase() == results.data[i].idType.trim().toLowerCase()}) || idTypes[0];
                            } else {
                                idType = "NRC";
                            }
                            
                            let user = {
                                name:results.data[i].username?results.data[i].username:'',
                                email:results.data[i].email?results.data[i].email:'',
                                firstname:results.data[i].firstname?results.data[i].firstname:'',
                                lastname:results.data[i].lastname?results.data[i].lastname:'',
                                middlename:results.data[i].middlename?results.data[i].middlename:'',
                                sex:gender,
                                
                                dateOfBirth: new Date(Date.UTC(results.data[i].dobYear?results.data[i].dobYear:0,results.data[i].dobMonth?results.data[i].dobMonth - 1:0,results.data[i].dobDay?results.data[i].dobDay:0)),
                                idType:idType,
                                idNumber:results.data[i].idNumber?results.data[i].idNumber:'',
                                nationality:nationality,
                                phone1:results.data[i].phone1?results.data[i].phone1:'',
                                phone2:results.data[i].phone2?results.data[i].phone2:'',
                                physicalAddress:results.data[i].physicalAddress?results.data[i].physicalAddress:'',
                                postalAddress:results.data[i].postalAddress?results.data[i].postalAddress:'',
                                district:district,	
                                program:results.data[i].program?results.data[i].program:'',
                                institution:results.data[i].institution?results.data[i].institution:'',
                                professionalCategory:professionalCategory,
                                employed:results.data[i].employed?results.data[i].employed:'',
                                employer:results.data[i].employer?results.data[i].employer:'',
                                employeeId:results.data[i].employeeId?results.data[i].employeeId:'',
                                organizationalUnit:results.data[i].organizationalUnit?results.data[i].organizationalUnit:'',
                                currentPosition:results.data[i].currentPosition?results.data[i].currentPosition:'',
                                facility:results.data[i].facility?results.data[i].facility:'',
                                password:results.data[i].password?results.data[i].password:'',
                                status:results.data[i].status?results.data[i].status:null
                            }
                            count++;
                            page.push(user);
                        }
                        i++;
                    }
                    newPages.push(page);
                }
                createDialog({
                    title:"Add Users",
                    Component:AddUsersTable,
                    params:{pages:newPages},
                    version:params.version?params.version:null,
                    setVersion:params.setVersion?params.setVersion:null
                })
                params.close && params.close();
            },
        });
    }

    const handleFileChosen = (file) => {
        let type = file.name.split('.').pop();
        if(type === 'csv') {
            fileReader = new FileReader();
            fileReader.onload = handleFileRead;
            fileReader.readAsText(file);
        }
    }

    useEffect(() => {
        request('GET','districts')
        .then((response) => {
            if(response && response.length > 0) {
                setDistricts(response);
            }  else {
                setDistricts([]);
            }
        })
        .catch((error) => {
            setDistricts([]);
        })

        request('GET','nationalities')
        .then((response) => {
            if(response && response.length > 0) {
                setNationalities(response);
            }  else {
                setNationalities([]);
            }
        })
        .catch((error) => {
            setNationalities([]);
        })

        request('GET','professionalcategories')
        .then((response) => {
            if(response) {
                setProfessionalCategories(response);
            }  else {
                setProfessionalCategories([]);
            }
        })
        .catch((error) => {
            setProfessionalCategories([]);
        })

        request('GET','idtypes')
        .then((response) => {
            if(response) {
                setIdTypes(response);
            }  else {
                setIdTypes([]);
            }
        })
        .catch((error) => {
            setIdTypes([]);
        })

        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                let height = entry.target.getBoundingClientRect().height;
            }
        });

        if(mainContainerRef.current) {
            observer.observe(mainContainerRef.current)
        }
        return () => {
            observer.disconnect();
        }
    },[]);

  return (
        <div className='flex w-full'>
            <div className='flex w-full h-[640px] p-8'>
                <div id="drop_zone" 
                    onDrop={(e) => {
                        e.preventDefault();
                        handleFileChosen(e.dataTransfer.files[0]);
                    }}
                    onDragOver={(e) => {
                        e.preventDefault();
                    }}
                    className='flex flex-col w-full h-full items-center justify-center text-[rgb(93,93,93)] bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg'>
                    <BiSolidCloudUpload size={64} className='text-theme'/>
                    <p className='text-xl'>Drag and drop csv files here</p>
                    <p className='text-lg'>-or-</p>
                    <input
                        type='file'
                        id='img'
                        name='userImage'
                        accept='.csv'
                        className='hidden'
                        onChange={(e) => {
                            handleFileChosen(e.target.files[0]);
                        }}
                    />
                    <label 
                        htmlFor='img' 
                        className='flex shrink-0 w-auto h-10 items-center justify-center text-xl hover:text-theme'
                    >
                        Browse
                    </label>
                </div>
            </div>
        </div>
  )
}

export default AddUsers